/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1220
 */

"use strict"

var r = require(/* 1555 */"./1555/index")
var /* [auto-meaningful-name] */r$default = r.default
var /* [auto-meaningful-name] */r$DraggableCore = r.DraggableCore
module.exports = r$default
module.exports.default = r$default
module.exports.DraggableCore = r$DraggableCore
